import { rankingList } from "@/mocks/home";
import Reveal from "@/components/feature/Reveal";

const rankStyles = [
  "bg-primary-500 text-background-50",
  "bg-accent-500 text-primary-950",
  "bg-secondary-400 text-background-50",
];

export default function RankingSection() {
  const top = rankingList[0];

  return (
    <section id="ranking" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-8">
        <div className="grid gap-10 lg:grid-cols-3 lg:gap-14">
          <div>
            <p className="font-label text-xs tracking-[0.3em] text-primary-600">HOT BOARD</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">人气热议榜</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              按围观热度排出的整理榜单。数字只是参考，真要弄明白，还是建议回到时间线里逐条对照。
            </p>

            <div className="mt-6 rounded-lg bg-primary-500 p-6 text-background-50">
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-3 py-1 font-label text-xs">
                <i className="ri-fire-line text-accent-400"></i>
                本期榜首
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold leading-snug">{top.title}</h3>
              <div className="mt-4 flex items-center justify-between border-t border-background-50/20 pt-4">
                <span className="font-label text-sm text-background-50/80">热度 {top.heat}</span>
                <span className="flex items-center gap-1 font-label text-sm text-accent-400">
                  <i className="ri-arrow-up-line"></i>
                  {top.change}
                </span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <ul className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {rankingList.map((item, index) => (
                <Reveal key={item.id} delay={index * 40}>
                  <li className="flex items-center gap-3 border-b border-background-200 px-4 py-4 last:border-b-0 md:gap-5 md:px-6">
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                        rankStyles[item.rank - 1] ?? "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {item.rank}
                    </span>

                    <div className="min-w-0 flex-1">
                      <h3 className="truncate font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {item.title}
                      </h3>
                      <span className="mt-1.5 inline-block rounded-full bg-secondary-100 px-2 py-0.5 font-label text-[11px] text-secondary-900">
                        {item.category}
                      </span>
                    </div>

                    <div className="shrink-0 text-right">
                      <div className="font-heading text-sm font-bold text-foreground-900 md:text-base">{item.heat}</div>
                      <div
                        className={`mt-1 flex items-center justify-end gap-1 font-label text-[11px] ${
                          item.trend === "up" ? "text-primary-600" : "text-foreground-400"
                        }`}
                      >
                        <i className={item.trend === "up" ? "ri-arrow-up-line" : "ri-arrow-down-line"}></i>
                        {item.change}
                      </div>
                    </div>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}